module.exports = __webpack_public_path__ + "static/images/styles/images/buildings/attack-bomber-squadrons-lvl3-50.8be0d2d1.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/buildings/attack-bomber-squadrons-lvl3-50.png
// module id = 3512
// module chunks = 11